import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { motion } from "framer-motion";
import member1 from "../../static/media/Home/Memberships/member1.webp";
import member2 from "../../static/media/Home/Memberships/member2.webp";

const PRIMARY = "#06BBC7";
const YELLOW = "#F7C948";
const YELLOW_HOVER = "#efbd35";

const memberships = [
  {
    title: "Membresía Facial",
    price: "$85",
    description:
      "Una opción pensada para mantener tu piel limpia, fresca y cuidada con protocolos faciales profesionales.",
    image: member1,
    bg: "#fffaf0",
    features: [
      "Limpieza profunda facial",
      "Cuidado facial mensual",
      "Tratamiento ideal para renovar la piel",
    ],
  },
  {
    title: "Membresía Renovación",
    price: "$120",
    description:
      "Un plan completo para revitalizar la piel con tratamientos combinados y atención estética personalizada.",
    image: member2,
    bg: "#ffffff",
    features: [
      "Limpieza profunda facial",
      "Mesoterapia con técnicas combinadas",
      "Evaluación previa según necesidad",
    ],
  },
];

const MotionBox = motion(Box);
const MotionButton = motion(Button);

const Memberships = () => {
  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        bgcolor: PRIMARY,
        py: { xs: 5, sm: 7, md: 9 },
        overflow: "hidden",
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: { xs: "block", md: "none" },
            textAlign: "center",
            mb: 3.5,
            px: 2,
          }}
        >
          <Typography
            sx={{
              color: "#ffffff",
              fontSize: { xs: "0.78rem", sm: "0.86rem" },
              fontWeight: 700,
              letterSpacing: "0.14em",
              textTransform: "uppercase",
              mb: 1.3,
            }}
          >
            Nuestras membresías
          </Typography>

          <Typography
            component="h2"
            sx={{
              fontFamily: "'Playfair Display', serif",
              color: "#ffffff",
              fontSize: {
                xs: "2.25rem",
                sm: "2.8rem",
              },
              fontWeight: 600,
              lineHeight: 1.04,
              letterSpacing: "-0.045em",
            }}
          >
            Los mejores resultados!!
          </Typography>
        </Box>

        <Box
          sx={{
            position: "relative",
            maxWidth: 1320,
            mx: "auto",
            borderRadius: { xs: "26px", md: "34px" },
            overflow: "hidden",
            boxShadow: "0 26px 60px rgba(0,0,0,0.16)",
          }}
        >
          <Box
            sx={{
              display: { xs: "none", md: "block" },
              position: "absolute",
              top: 62,
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 3,
              width: "62%",
              textAlign: "center",
              px: 3,
            }}
          >
            <Typography
              sx={{
                color: "#111827",
                fontSize: { md: "0.95rem" },
                fontWeight: 700,
                letterSpacing: "0.14em",
                textTransform: "uppercase",
                mb: 1.3,
              }}
            >
              Nuestras membresías
            </Typography>

            <Typography
              component="h2"
              sx={{
                fontFamily: "'Playfair Display', serif",
                color: "#111827",
                fontSize: {
                  md: "3.5rem",
                },
                fontWeight: 600,
                lineHeight: 1.04,
                letterSpacing: "-0.045em",
              }}
            >
              Los mejores resultados!!
            </Typography>
          </Box>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                md: "repeat(2, minmax(0, 1fr))",
              },
              alignItems: "stretch",
            }}
          >
            {memberships.map((item, index) => (
              <Box
                key={item.title}
                sx={{
                  bgcolor: item.bg,
                  px: { xs: 2.2, sm: 3.4, md: 4.2, lg: 5 },
                  pt: {
                    xs: index === 0 ? 4 : 4,
                    md: 25,
                  },
                  pb: { xs: 4, md: 5.5 },
                  minHeight: { xs: "auto", md: 760 },
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  borderTop: {
                    xs:
                      index === 1
                        ? "1px solid rgba(6,187,199,0.2)"
                        : "none",
                    md: "none",
                  },
                }}
              >
                <MotionBox
                  initial={{ opacity: 0, y: 24, scale: 0.98 }}
                  whileInView={{ opacity: 1, y: 0, scale: 1 }}
                  viewport={{ once: true, amount: 0.25 }}
                  transition={{
                    duration: 0.65,
                    delay: index * 0.12,
                    ease: "easeOut",
                  }}
                  sx={{
                    width: "100%",
                    maxWidth: { xs: 390, sm: 440, md: 460, lg: 500 },
                    mx: "auto",
                    mb: { xs: 2.5, md: 3 },
                    borderRadius: { xs: "20px", md: "24px" },
                    overflow: "hidden",
                    bgcolor: "#ffffff",
                    boxShadow: "0 16px 34px rgba(15,23,42,0.1)",
                  }}
                >
                  <Box
                    component="img"
                    src={item.image}
                    alt={item.title}
                    loading="lazy"
                    sx={{
                      width: "100%",
                      height: "auto",
                      display: "block",
                    }}
                  />
                </MotionBox>

                <Typography
                  component="h3"
                  sx={{
                    color: "#111827",
                    fontSize: { xs: "1.75rem", sm: "2.05rem", md: "2.2rem" },
                    fontWeight: 600,
                    lineHeight: 1.08,
                    fontFamily: "'Playfair Display', serif",
                    mb: 1.2,
                  }}
                >
                  {item.title}
                </Typography>

                <Typography
                  sx={{
                    color: PRIMARY,
                    fontSize: { xs: "2.25rem", sm: "2.8rem", md: "3.5rem" },
                    fontWeight: 600,
                    lineHeight: 0.95,
                    mb: 2,
                  }}
                >
                  {item.price}
                </Typography>

                <Typography
                  sx={{
                    color: "#374151",
                    fontSize: { xs: "0.96rem", md: "1.02rem" },
                    fontWeight: 400,
                    lineHeight: 1.7,
                    maxWidth: 490,
                    mb: 2.4,
                  }}
                >
                  {item.description}
                </Typography>

                <Box
                  sx={{
                    width: "100%",
                    maxWidth: 500,
                    borderTop: "1px solid rgba(6,187,199,0.32)",
                    pt: 2.2,
                    mb: 3,
                  }}
                >
                  {item.features.map((feature) => (
                    <Typography
                      key={feature}
                      sx={{
                        color: "#1f2937",
                        fontSize: { xs: "0.95rem", md: "1rem" },
                        fontWeight: 500,
                        lineHeight: 1.65,
                        mb: 0.8,
                      }}
                    >
                      {feature}
                    </Typography>
                  ))}
                </Box>

                <MotionButton
                  component={RouterLink}
                  to="/agendar-cita"
                  variant="contained"
                  initial={{ opacity: 0, y: 18 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.35 }}
                  transition={{
                    duration: 0.5,
                    delay: 0.18 + index * 0.12,
                    ease: "easeOut",
                  }}
                  whileHover={{ y: -3 }}
                  whileTap={{ scale: 0.97 }}
                  sx={{
                    mt: "auto",
                    bgcolor: YELLOW,
                    color: "#1f2937",
                    px: 4,
                    py: 1.18,
                    borderRadius: "999px",
                    textTransform: "none",
                    fontWeight: 700,
                    fontSize: "0.95rem",
                    boxShadow: "none",
                    textDecoration: "none",
                    "&:hover": {
                      bgcolor: YELLOW_HOVER,
                      boxShadow: "0 14px 28px rgba(246, 217, 120, 0.3)",
                    },
                  }}
                >
                  Agendar Cita
                </MotionButton>
              </Box>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Memberships;